export const GS = {
  ink: '#061524',
  text: '#0B1E2D',
  muted: '#5B6B87',
  muted2: '#8B99B4',
  line: '#DEE4F0',
  lineSoft: '#EAEFF7',
  surface: '#FFFFFF',
  surface2: '#F7F9FD',
  canvas: '#F1F4FA',
  navy: '#00146D',
  navy2: '#1B2F8F',
  teal: '#0D9B87',
  tealDeep: '#076B5C',
  tealSoft: '#E2F7F2',
  font: 'Lato, sans-serif',
} as const

export const getStartedFieldSx = {
  '& .MuiOutlinedInput-root': {
    fontFamily: GS.font,
    fontSize: 15,
    borderRadius: '8px',
    backgroundColor: '#fff',
    minHeight: 48,
    '& fieldset': { borderColor: GS.line },
    '&:hover fieldset': { borderColor: GS.muted2 },
    '&.Mui-focused fieldset': {
      borderColor: GS.teal,
      borderWidth: '1.5px',
    },
    '&.Mui-focused': {
      boxShadow: '0 0 0 3px rgba(13,155,135,0.14)',
    },
  },
  '& .MuiOutlinedInput-input': {
    fontSize: 15,
    py: '12px',
  },
  '& .MuiInputLabel-root': {
    fontFamily: GS.font,
    fontSize: 14.5,
    color: GS.muted,
    '&.Mui-focused': { color: GS.tealDeep },
  },
  '& .MuiFormHelperText-root': {
    fontFamily: GS.font,
    fontSize: 13,
  },
}

export const getStartedPrimaryBtnSx = {
  fontFamily: GS.font,
  fontWeight: 700,
  fontSize: 15.5,
  textTransform: 'none' as const,
  borderRadius: '8px',
  px: 3,
  py: 1.4,
  minHeight: 48,
  bgcolor: GS.navy,
  boxShadow: '0 1px 2px rgba(0,20,109,0.35)',
  '&:hover': { bgcolor: GS.navy2 },
  '&.Mui-disabled': { bgcolor: '#A8B0C9', color: '#fff' },
}

export const getStartedSecondaryBtnSx = {
  fontFamily: GS.font,
  fontWeight: 600,
  fontSize: 15,
  textTransform: 'none' as const,
  borderRadius: '8px',
  minHeight: 48,
  borderColor: GS.line,
  color: GS.text,
  '&:hover': {
    borderColor: GS.muted2,
    bgcolor: GS.surface2,
  },
}
